/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_Co2_TitleInputs */

const en_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You reduced ${i?.number} kg of CO₂!`)
};

const ar_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`لقد خفضت ${i?.number} كجم من ثاني أكسيد الكربون!`)
};

const de_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sie haben ${i?.number} kg CO₂ reduziert!`)
};

const es_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Has reducido ${i?.number} kg de CO₂!`)
};

const fr_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez réduit les émissions de CO₂ de ${i?.number} kg !`)
};

const it_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai ridotto ${i?.number} kg di CO₂!`)
};

const ja_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}kgのCO₂を削減しました！`)
};

const ko_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}kg의 CO₂를 감축했어요!`)
};

const pt_br_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você reduziu ${i?.number} kg de CO₂!`)
};

const ru_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы сократили ${i?.number} кг CO₂!`)
};

const th_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณได้ลดการปล่อย CO₂ ${i?.number} กก.!`)
};

const tr_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} kg CO₂ azalttın!`)
};

const zh_cn_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你帮地球减少了 ${i?.number} 公斤的二氧化碳！`)
};

const zh_tw_earth_day_2025_impact_co2_title = /** @type {(inputs: Earth_Day_2025_Impact_Co2_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你幫地球減少了 ${i?.number} 公斤的二氧化碳！`)
};

/**
* | output |
* | --- |
* | "You reduced {number} kg of CO₂!" |
*
* @param {Earth_Day_2025_Impact_Co2_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_co2_title = /** @type {((inputs: Earth_Day_2025_Impact_Co2_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Co2_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_co2_title(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_co2_title(inputs)
	if (locale === "de") return de_earth_day_2025_impact_co2_title(inputs)
	if (locale === "es") return es_earth_day_2025_impact_co2_title(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_co2_title(inputs)
	if (locale === "it") return it_earth_day_2025_impact_co2_title(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_co2_title(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_co2_title(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_co2_title(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_co2_title(inputs)
	if (locale === "th") return th_earth_day_2025_impact_co2_title(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_co2_title(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_co2_title(inputs)
	return zh_tw_earth_day_2025_impact_co2_title(inputs)
});